import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import { cn } from '../lib';
import { Input, InputGroup } from '../ui';

interface ISearchBarInputProps {
  className?: string;
  label: string;
  maxLength?: number;
  onInputChange: (searchText: string) => void;
  placeholder: string;
  searchKey: string;
}

/**
 * -----------------------------------------------------------------------------
 * This is to be used as a building block for search options.
 */
export function SearchBarInput({
  className,
  label,
  maxLength,
  placeholder,
  searchKey,
  onInputChange,
}: ISearchBarInputProps) {
  return (
    <InputGroup className={cn('flex w-full max-w-xl grow', className)}>
      <MagnifyingGlassIcon />
      <Input
        aria-label={label}
        delay={300}
        maxLength={maxLength}
        name="search"
        onChangeDebounced={onInputChange}
        placeholder={placeholder}
        value={searchKey}
      />
    </InputGroup>
  );
}
